// extracted by mini-css-extract-plugin
export default {"header":"Layout_header__k1u9F","header__container":"Layout_header__container__eRIQR","brand__container":"Layout_brand__container__SuMj1","app__brand":"Layout_app__brand__u1e18"};